import { createAction } from "@reduxjs/toolkit"
import { LicenseModalContext, LicensePaywallType } from "./types"
import { AddOns } from "@nova/constants"
import { License } from "@nova/schemas"

export const setLicenseModalContext = createAction<LicenseModalContext>(
    "licenses/setLicenseModalContext"
)

export const setAddOnPaywallType = createAction<AddOns | undefined>("licenses/setAddOnPaywallType")
export const setLicenseUpgrade = createAction<License | undefined>("licenses/setLicenseUpgrade")
export const setLicensePaywallType = createAction<LicensePaywallType>(
    "licenses/setLicensePaywallType"
)
